import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { Box } from '@vk-hr-tek/ui/Box';
import { FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { FormKnownValue, FormKnownValues } from '@vk-hr-tek/ui/form';
import { Link } from '@vk-hr-tek/ui/Link';
import { Redo } from '@vk-hr-tek/ui/Redo';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Callout } from '@vk-hr-tek/ui/Callout';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { useDispatch, useSelector } from '@app/hooks';

import {
  selectNotification,
  selectPhone,
  selectStatus,
  selectSnils,
  selectPassword,
  changePasswordInit,
  redirectToSendInviteForPhone,
  changePassword,
  setStage,
} from '../../../slice';
import { ChangePasswordDto, ChangePasswordInitDto } from '../../../dto';
import { Button } from '../../../segments';
import { useGetAuthInstance } from '../../../hooks';

export const ChangePasswordVerifyCode = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);

  const phone = useSelector(selectPhone);
  const snils = useSelector(selectSnils);
  const password = useSelector(selectPassword);
  const error = useSelector(selectNotification);
  const status = useSelector(selectStatus);
  const authInstance = useGetAuthInstance();

  const { button_color: buttonColor } = authInstance;

  const onSubmit = ({ code }: ChangePasswordDto) => {
    new Promise((resolve) => {
      dispatch(
        changePassword({
          values: {
            code,
            password: password as string,
            phone: phone as string,
            snils: snils as string,
            passwordRepeat: password as string,
          },
          actions: { resolve },
        }),
      );
    });
  };

  const resendCode = () => {
    new Promise((resolve) => {
      dispatch(
        changePasswordInit({
          values: { phone, snils } as ChangePasswordInitDto,
          actions: { resolve },
        }),
      );
    });
  };

  const handleRedirectToSendInviteForPhone = () =>
    dispatch(redirectToSendInviteForPhone());

  const handleSetStage = () => dispatch(setStage('verification'));

  return (
    <Form
      validate={(values) =>
        validator.validate(values, ChangePasswordDto, ['code-verify'])
      }
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        submitting,
        pristine,
        hasValidationErrors,
        dirtySinceLastSubmit,
      }) => (
        <form onSubmit={handleSubmit}>
          <FormKnownValues>
            <FormKnownValue label="СНИЛС" value={snils} />
            <FormKnownValue
              label="Номер телефона"
              value={phone}
              verified={false}
            />
          </FormKnownValues>
          <Box mt="24">
            <TextInput
              name="code"
              label="Код подтверждения"
              placeholder="Введите код"
              type="number"
              inputMode="numeric"
              autocomplete="one-time-code"
              id="qaAuthChangePasswordVerifyCodeInput"
              testId="test-id-verify-code-input"
            />
          </Box>
          <Box mb="12">
            <Callout>
              <Typography color="text.light.primary" variant="body3">
                Код поступит в MAX или придёт по СМС
              </Typography>
            </Callout>
          </Box>
          <Redo label="Отправить код повторно" action={resendCode} />
          <Box mt={{ xs: '32', md: '48' }}>
            <Button
              color={buttonColor && `#${buttonColor}`}
              disabled={pristine || hasValidationErrors}
              loading={submitting}
              testId="test-id-code-submit-button"
            >
              Подтвердить
            </Button>
          </Box>
          {!dirtySinceLastSubmit && status && status === 'failed' && (
            <FormError error={error} />
          )}
          <Box
            mt={{ xs: '24', md: '16' }}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Link
              onClick={handleSetStage}
              size="small"
              variant="tertiary"
              startIcon={<Icon name="chevron_left" size="16" />}
            >
              Вернуться назад
            </Link>
            <Link
              onClick={handleRedirectToSendInviteForPhone}
              size="small"
              variant="tertiary"
            >
              Я сменил телефон
            </Link>
          </Box>
        </form>
      )}
    />
  );
};
